import React from 'react';

function Stats() {
  return <div>Stats page is under development...</div>;
}

export default Stats;
